import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from 'src/environment/environment';
import { Router } from '@angular/router';
import { OtpauthService } from '../otpservice/otp.service.service';
import { SharedService } from '../sharedservice/shared.service.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private otpAuthService!: OtpauthService;
  private isClearingData = false;

  baseUrl = `${environment.baseUrl}/api/v1/`;

  constructor(private http: HttpClient, private router:Router, private injector: Injector, private sharedService: SharedService) { }

   isAuthenticated(): boolean {
    const token = localStorage.getItem('token');

    if (!token) {
      return false;
    }

    const tokenExpiry = this.decodeTokenExpiry(token);
    if (tokenExpiry < Date.now()) {
      this.clearData();
      return false;
    }

    return true;
  }

  private decodeTokenExpiry(token: string): number {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  }

  postRequest(endpoint: string, data: any): Observable<any> {
    const options = {
      withCredentials: true
    };
    return this.http.post(this.baseUrl + endpoint, data, options);
  }

  putRequest(endpoint: string, data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.put(this.baseUrl + endpoint, data, options)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  getRequest(endpoint: string): Observable<any> {
    const options = {
      withCredentials: true
    };
    return this.http.get(this.baseUrl + endpoint, options)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  getParamRequest(endpoint: string, params: any): Observable<any> {
    const options = {
      params: params,
      withCredentials: true
    };
    return this.http.get(this.baseUrl + endpoint, options)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  deleteRequest(endpoint: string, body: any, params?: any): Observable<any> {
    const options = {
      body: body,
      params: new HttpParams({ fromObject: params }),
      withCredentials: true
    };
    return this.http.request('DELETE', this.baseUrl + endpoint, options)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  deleteOneRequest(endpoint: string): Observable<any> {
    const options = {
      withCredentials: true
    };
    return this.http.request('DELETE', this.baseUrl + endpoint, options)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  getStatus(endpoint: string): Observable<any> {
    return this.http.get(endpoint).pipe(
      catchError((error: any) => {
        if (error.status === 404) {
          console.log(`Endpoint not found: ${endpoint}`);
        } else {
          console.log(`Error fetching data from ${endpoint}:`, error);
        }
        return of(null);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  private getOtpAuthService(): OtpauthService {
    if (!this.otpAuthService) {
      this.otpAuthService = this.injector.get(OtpauthService);
    }
    return this.otpAuthService;
  }

  clearData(): void {
    if (this.isClearingData) return;
    this.isClearingData = true;
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.removeItem('/treeData');
    this.getOtpAuthService().resetOtpState();
    this.sharedService.userPermissions.next(null);
    this.sharedService.poralConfiguration$.next({});
    this.sharedService.userStore = {};
    this.router.navigate(['/login']);
    setTimeout(() => {
        this.isClearingData = false;
    }, 0);
  }
}
